<div class="leftmenu" [class.menu-collapsed]="isMenuCollapsed">
  <div class="menu-section" role="navigation">
    @for (menuItem of mainMenu; track $index) {
      @if (selectedMenuItem$ | async; as selectedItem) {
        <div
          class="menu-item"
          [class.expanded]="menuItem.isExpanded"
          [id]="'tour-menu-item-' + menuItem.route"
        >
          <a
            [routerLink]="menuItem.sub.length ? null : ['/' + menuItem.route]"
            [queryParams]="menuItem.queryParams"
            href="javascript:void(0)"
            [class.active]="
              selectedItem === menuItem ||
              isSubMenuActive(menuItem, selectedItem)
            "
            [id]="'tour-menu-item-sub-' + menuItem.route"
            (click)="
              menuItem.sub.length
                ? tourService.isTourMode
                  ? openSubmenu(menuItem)
                  : toggleSubmenu(menuItem)
                : null
            "
          >
            <app-svg-icon
              [iconName]="menuItem.iconURL"
              [title]="menuItem.name"
              [width]="'22px'"
              [height]="'22px'"
              [style.fill]="'#4a4a4a'"
            ></app-svg-icon>
            <span
              class="menu-text"
              [style.cursor]="menuItem.sub.length ? 'default' : 'pointer'"
              >{{ menuItem.name }}</span
            >
            @if (menuItem.sub.length) {
              <span class="expand-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path
                    d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                  />
                </svg>
              </span>
            }
          </a>
          @if (menuItem.sub.length) {
            <div class="submenu">
              @for (subItem of menuItem.sub; track $index) {
                <a
                  [routerLink]="['/' + menuItem.route + '/' + subItem.route]"
                  [queryParams]="subItem.queryParams"
                  href="javascript:void(0)"
                  [class.active]="selectedItem === subItem"
                >
                  <app-svg-icon
                    [iconName]="subItem.iconURL"
                    [title]="subItem.name"
                    [width]="'18px'"
                    [height]="'18px'"
                    [style.fill]="'#4a4a4a'"
                  ></app-svg-icon>
                  <span class="menu-text">{{ subItem.name }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    }
  </div>

  @if (adminMenu.length > 0) {
    <div class="menu-section" role="navigation">
      @for (menuItem of adminMenu; track $index) {
        @if (selectedMenuItem$ | async; as selectedItem) {
          <div class="menu-item" [class.expanded]="menuItem.isExpanded">
            <a
              [routerLink]="menuItem.sub.length ? null : ['/' + menuItem.route]"
              href="javascript:void(0)"
              [id]="'tour-menu-item-' + menuItem.route"
              [class.active]="
                selectedItem === menuItem ||
                isSubMenuActive(menuItem, selectedItem)
              "
              (click)="menuItem.sub.length ? toggleSubmenu(menuItem) : null"
            >
              <app-svg-icon
                [iconName]="menuItem.iconURL"
                [title]="menuItem.name"
                [width]="'22px'"
                [height]="'22px'"
                [style.fill]="'#4a4a4a'"
              ></app-svg-icon>
              <span
                class="menu-text"
                [style.cursor]="menuItem.sub.length ? 'default' : 'pointer'"
                >{{ menuItem.name }}</span
              >
              @if (menuItem.sub.length) {
                <span class="expand-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path
                      d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                    />
                  </svg>
                </span>
              }
            </a>
            @if (menuItem.sub.length) {
              <div class="submenu">
                @for (subItem of menuItem.sub; track $index) {
                  <a
                    [routerLink]="['/' + menuItem.route + '/' + subItem.route]"
                    [queryParams]="subItem.queryParams"
                    href="javascript:void(0)"
                    [class.active]="selectedItem === subItem"
                  >
                    <app-svg-icon
                      [iconName]="subItem.iconURL"
                      [title]="subItem.name"
                      [width]="'18px'"
                      [height]="'18px'"
                      [style.fill]="'#4a4a4a'"
                    ></app-svg-icon>
                    <span class="menu-text">{{ subItem.name }}</span>
                  </a>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  }

  <div class="bottom-section">
    @if (crmStatus) {
      <div class="crm-section">
        <a
          href="javascript:void(0)"
          class="crm-standalone-btn"
          title="Go to CRM"
          (click)="openCRM()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M7 7h10v10M7 17L17 7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Go to CRM</span>
        </a>
      </div>
    }
    <div class="bottom-container">
      @if (!isMenuCollapsed) {
        <div
          class="logo-container"
          [id]="isSMEUser ? 'tour-sme-logo' : 'tour-cdfi-logo'"
        >
          <div class="image-wrapper">
            <img
              [src]="connectionUrl"
              alt="CDFI Logo"
              class="logo-image"
              (error)="onImageError()"
              [class.hidden]="!imageLoaded"
            />
            @if (!imageLoaded) {
              <span class="connection-text">{{ connectionName }}</span>
            }
          </div>
        </div>
      }
      <div class="collapse-arrow" id="tour-side-menu-toggle">
        <a
          href="javascript:void(0)"
          (click)="toggleMenu()"
          [title]="isMenuCollapsed ? 'Expand Menu' : 'Collapse Menu'"
        >
          @if (isMenuCollapsed) {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
              />
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
              />
            </svg>
          }
        </a>
      </div>
    </div>
  </div>
</div>
